function isNowHoliday() {
  const thisMonth = new Date().getMonth() + 1;
  const isHoliday = thisMonth === 7 || thisMonth === 8;

  return isHoliday;
}

export default isNowHoliday;
